export default {
    namespaced: true,
    state: {
        isModalOpen: false,
        modalTimeStamp: '',
        errors: {
            requestHelp: {}
        }
    },
    mutations: {
        SET_IS_MODAL_OPEN(state, payload) {
            state.isModalOpen = payload
        },
        SET_MODAL_TIMESTAMP(state, payload) {
            state.modalTimeStamp = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async requestHelp({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'requestHelp',
                val: {}
            })

            const url = '/user/help'

            try {
                const resp = await this.$axios.post(url, data)
                return resp.data
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'requestHelp',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'requestHelp',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
